import { ProfileIcon, SecurityIcon } from "@simulanisindia/ui";
import { PLAN_DETAIL_TAB, RESOURCE_APPLICATION_TAB, RESOURCE_ENVIRONMENT_TAB, RESOURCE_MODULE_TAB, RESOURCE_SKILL_SCHOOL_TAB, RESOURCE_SKILL_STREAM_TAB, VALIDITY_TAB } from "../../Constant/constant";

export const menuData = [
    {
        id: 1,
        title: "Select Resources",
        icon: <SecurityIcon />,
        hasDropdown: true,
        isDisabled: false,
        id_link: `${RESOURCE_APPLICATION_TAB}`,
        submenu: [
            { title: "Application", id_link: `${RESOURCE_APPLICATION_TAB}` },
            { title: "XR Modules", id_link: `${RESOURCE_MODULE_TAB}` },
            { title: "Environments", id_link: `${RESOURCE_ENVIRONMENT_TAB}` },
            { title: "Skill Stream", id_link: `${RESOURCE_SKILL_STREAM_TAB}` },
            { title: "Skill School", id_link: `${RESOURCE_SKILL_SCHOOL_TAB}` },
        ],
    },
    {
        id: 2,
        title: "Validity",
        icon: <ProfileIcon />,
        hasDropdown: true,
        isDisabled: true,
        id_link: `${VALIDITY_TAB}`,
        submenu: [],
    },
    {
        id: 2,
        title: "Plan Details",
        icon: <ProfileIcon />,
        hasDropdown: true,
        isDisabled: true,
        id_link: `${PLAN_DETAIL_TAB}`,
        submenu: [
            // { title: "Invoice", id_link: "invoice" },
            // { title: "Expiry Alets", id_link: "expiry-alerts" },
        ],
    },
];